export const worldScale = 40;
export const movementSpeed = 10;
export const navigationGridSize = 0.5;
export const enemyGroupHitRadius = 0.55;
export const playerCollisionRadius = 0.35;
export const collidableRectFeatureKinds = new Set(["wall", "water", "rock"]);
export const debugFightEnemies = [
  { id: "field_rabbit", name: "Field Rabbit", aliases: ["rabbit", "field", "bunny"] },
  { id: "angry_rabbit", name: "Angry Rabbit", aliases: ["angry", "angry rabbit"] },
  { id: "cave_rat", name: "Cave Rat", aliases: ["rat", "cave"] },
  { id: "plague_rat", name: "Plague Rat", aliases: ["plague", "plague rat"] },
  { id: "forest_wolf", name: "Forest Wolf", aliases: ["wolf", "forest"] },
  { id: "old_forest_wolf", name: "Old Forest Wolf", aliases: ["old wolf", "old forest wolf"] },
  { id: "dock_smuggler", name: "Dock Smuggler", aliases: ["smuggler", "dock"] },
  { id: "wax_smuggler", name: "Black-Wax Smuggler", aliases: ["wax", "black wax", "black-wax smuggler"] },
  { id: "pijany_grzegorz", name: "Drunk Grzegorz", aliases: ["grzegorz", "drunk"] },
];

export const itemIconIds = [
  "angry_paw_charm",
  "ash_captain_saber",
  "ashwood_wand",
  "black_wax_signet",
  "brass_focus_ring",
  "burrow_moon_crown",
  "cieply_koc",
  "cieply_posilek",
  "czarna_sol",
  "czerwony_skos",
  "dockhand_belt",
  "dziennik_karawany",
  "dziki_grzyb",
  "field_hunter_blade",
  "field_ration",
  "gnawmarked_greaves",
  "gorzka_mieta",
  "gorzka_mieta_lisc",
  "greyfang_last_tooth",
  "gutter_queen_sash",
  "harbor_note",
  "hedge_bow",
  "kamien_grzbietu",
  "kartka_dluzna",
  "korzen_ciszy",
  "ksiega_dlugow",
  "ksiega_ognia",
  "lisc_swiadkow",
  "mapa_suchej_sciany",
  "maska_wygnancow",
  "militia_iron_cap",
  "mokry_list",
  "moonhide_mantle",
  "napar_z_gorzkiej_miety",
  "nimble_foot_charm",
  "odlam_masywu",
  "old_wolf_tooth",
  "ostrze_pogorzelca",
  "patched_cloth_armor",
  "pekniety_kilof",
  "pierwszy_kamien_domu",
  "plague_touched_ring",
  "plagueglass_loop",
  "plank_guard",
  "popiol_z_traktu",
  "prosty_zelazny_sztylet",
  "przysiega_lasu",
  "rabbit_skin",
  "rain_singer_cloak",
  "rat_tail",
  "red_executor_saber",
  "ridge_tollblade",
  "rootgnaw_amulet",
  "rough_leather_vest",
  "rozkaz_bez_podpisu",
  "rozpiska_przemytu",
  "ruda_zelaza",
  "scout_bow",
  "sewer_glass_loop",
  "slodka_przyneta",
  "smuggler_hookknife",
  "solny_znak",
  "spalony_medalion",
  "splintered_sling",
  "stare_buty",
  "szal_ocalej",
  "salt_vein_greaves",
  "training_sword",
  "tomorrow_letter_ring",
  "willow_focus",
  "wolf_pelt",
  "wolfhide_jerkin",
  "wolfstep_boots",
  "worek_maki",
  "worek_soli",
  "wstega_przeprawy",
  "wzor_falszywej_wstegi",
  "zawyzone_ceny",
  "zeznanie_rutki",
  "znak_grzbietu",
  "znak_przewoznika",
  "znak_sprawcy",
  "znak_wozu",
  "dry_wall_bulwark",
  "name_burner_focus",
  "oathwarden_halfhelm",
];

export const itemIconPaths = {
  item_rabbit_skin: "/static/assets/items/rabbit_skin.png?v=item-icons-1",
  ...Object.fromEntries(
    itemIconIds
      .filter((itemId) => itemId !== "rabbit_skin")
      .map((itemId) => [`item_${itemId}`, `/static/assets/items/${itemId}.png?v=item-icons-1`]),
  ),
};

export const skeletalBasePartIds = [
  "chest",
  "foot_l",
  "foot_r",
  "forearm_l",
  "forearm_r",
  "hand_l",
  "hand_r",
  "head",
  "pelvis",
  "shin_l",
  "shin_r",
  "thigh_l",
  "thigh_r",
  "torso",
  "upper_arm_l",
  "upper_arm_r",
];

export const skeletalEquipmentPartPaths = {
  skeletal_equipment_angry_paw_charm_chest: "/static/assets/player/skeletal/equipment/angry_paw_charm/chest.png?v=skeletal-player-3",
  skeletal_equipment_ash_captain_saber_weapon_r: "/static/assets/player/skeletal/equipment/ash_captain_saber/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_ashwood_wand_weapon_r: "/static/assets/player/skeletal/equipment/ashwood_wand/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_black_wax_signet_hand_l: "/static/assets/player/skeletal/equipment/black_wax_signet/hand_l.png?v=skeletal-player-3",
  skeletal_equipment_brass_focus_ring_hand_l: "/static/assets/player/skeletal/equipment/brass_focus_ring/hand_l.png?v=skeletal-player-3",
  skeletal_equipment_burrow_moon_crown_head: "/static/assets/player/skeletal/equipment/burrow_moon_crown/head.png?v=skeletal-player-3",
  skeletal_equipment_dockhand_belt_pelvis: "/static/assets/player/skeletal/equipment/dockhand_belt/pelvis.png?v=skeletal-player-3",
  skeletal_equipment_dry_wall_bulwark_offhand_l: "/static/assets/player/skeletal/equipment/dry_wall_bulwark/offhand_l.png?v=skeletal-player-3",
  skeletal_equipment_field_hunter_blade_weapon_r: "/static/assets/player/skeletal/equipment/field_hunter_blade/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_gnawmarked_greaves_pelvis: "/static/assets/player/skeletal/equipment/gnawmarked_greaves/pelvis.png?v=skeletal-player-3",
  skeletal_equipment_greyfang_last_tooth_chest: "/static/assets/player/skeletal/equipment/greyfang_last_tooth/chest.png?v=skeletal-player-3",
  skeletal_equipment_gutter_queen_sash_pelvis: "/static/assets/player/skeletal/equipment/gutter_queen_sash/pelvis.png?v=skeletal-player-3",
  skeletal_equipment_hedge_bow_weapon_r: "/static/assets/player/skeletal/equipment/hedge_bow/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_militia_iron_cap_head: "/static/assets/player/skeletal/equipment/militia_iron_cap/head.png?v=skeletal-player-3",
  skeletal_equipment_moonhide_mantle_chest: "/static/assets/player/skeletal/equipment/moonhide_mantle/chest.png?v=skeletal-player-3",
  skeletal_equipment_name_burner_focus_chest: "/static/assets/player/skeletal/equipment/name_burner_focus/chest.png?v=skeletal-player-3",
  skeletal_equipment_nimble_foot_charm_chest: "/static/assets/player/skeletal/equipment/nimble_foot_charm/chest.png?v=skeletal-player-3",
  skeletal_equipment_oathwarden_halfhelm_head: "/static/assets/player/skeletal/equipment/oathwarden_halfhelm/head.png?v=skeletal-player-3",
  skeletal_equipment_old_wolf_tooth_chest: "/static/assets/player/skeletal/equipment/old_wolf_tooth/chest.png?v=skeletal-player-3",
  skeletal_equipment_patched_cloth_armor_torso: "/static/assets/player/skeletal/equipment/patched_cloth_armor/torso.png?v=skeletal-player-3",
  skeletal_equipment_plague_touched_ring_chest: "/static/assets/player/skeletal/equipment/plague_touched_ring/chest.png?v=skeletal-player-3",
  skeletal_equipment_plagueglass_loop_hand_l: "/static/assets/player/skeletal/equipment/plagueglass_loop/hand_l.png?v=skeletal-player-3",
  skeletal_equipment_plank_guard_offhand_l: "/static/assets/player/skeletal/equipment/plank_guard/offhand_l.png?v=skeletal-player-3",
  skeletal_equipment_prosty_zelazny_sztylet_weapon_r: "/static/assets/player/skeletal/equipment/prosty_zelazny_sztylet/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_rain_singer_cloak_chest: "/static/assets/player/skeletal/equipment/rain_singer_cloak/chest.png?v=skeletal-player-3",
  skeletal_equipment_red_executor_saber_weapon_r: "/static/assets/player/skeletal/equipment/red_executor_saber/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_ridge_tollblade_weapon_r: "/static/assets/player/skeletal/equipment/ridge_tollblade/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_rootgnaw_amulet_neck: "/static/assets/player/skeletal/equipment/rootgnaw_amulet/neck.png?v=skeletal-player-3",
  skeletal_equipment_rough_leather_vest_torso: "/static/assets/player/skeletal/equipment/rough_leather_vest/torso.png?v=skeletal-player-3",
  skeletal_equipment_salt_vein_greaves_pelvis: "/static/assets/player/skeletal/equipment/salt_vein_greaves/pelvis.png?v=skeletal-player-3",
  skeletal_equipment_scout_bow_weapon_r: "/static/assets/player/skeletal/equipment/scout_bow/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_sewer_glass_loop_hand_l: "/static/assets/player/skeletal/equipment/sewer_glass_loop/hand_l.png?v=skeletal-player-3",
  skeletal_equipment_smuggler_hookknife_weapon_r: "/static/assets/player/skeletal/equipment/smuggler_hookknife/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_splintered_sling_weapon_r: "/static/assets/player/skeletal/equipment/splintered_sling/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_tomorrow_letter_ring_hand_l: "/static/assets/player/skeletal/equipment/tomorrow_letter_ring/hand_l.png?v=skeletal-player-3",
  skeletal_equipment_training_sword_weapon_r: "/static/assets/player/skeletal/equipment/training_sword/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_willow_focus_weapon_r: "/static/assets/player/skeletal/equipment/willow_focus/weapon_r.png?v=skeletal-player-3",
  skeletal_equipment_wolfhide_jerkin_torso: "/static/assets/player/skeletal/equipment/wolfhide_jerkin/torso.png?v=skeletal-player-3",
  skeletal_equipment_wolfstep_boots_foot_r: "/static/assets/player/skeletal/equipment/wolfstep_boots/foot_r.png?v=skeletal-player-3",
};

export const assetPaths = {
  player: "/static/assets/map-icons/player.png?v=map-icons-1",
  npc: "/static/assets/map-icons/npc.png?v=map-icons-2",
  guard: "/static/assets/map-icons/guard.png?v=map-icons-2",
  merchant: "/static/assets/map-icons/merchant.png?v=map-icons-2",
  quest_npc: "/static/assets/map-icons/quest_npc.png?v=map-icons-2",
  portal: "/static/assets/map-icons/portal.png?v=map-icons-1",
  enemy: "/static/assets/map-icons/enemy.png?v=map-icons-1",
  wolf: "/static/assets/map-icons/wolf.png?v=map-icons-1",
  rat: "/static/assets/map-icons/rat.png?v=map-icons-1",
  rabbit: "/static/assets/map-icons/rabbit.png?v=map-icons-1",
  chest: "/static/assets/map-icons/chest.png?v=map-icons-1",
  herb: "/static/assets/map-icons/herb.png?v=map-icons-1",
  trace: "/static/assets/map-icons/trace.png?v=map-icons-1",
  document: "/static/assets/map-icons/document.png?v=map-icons-1",
  crate: "/static/assets/map-icons/crate.png?v=map-icons-1",
  cache: "/static/assets/map-icons/cache.png?v=map-icons-1",
  camp: "/static/assets/map-icons/camp.png?v=map-icons-1",
  cart: "/static/assets/map-icons/cart.png?v=map-icons-1",
  equipment: "/static/assets/map-icons/equipment.png?v=map-icons-1",
  item: "/static/assets/map-icons/item.png?v=map-icons-1",
  notice: "/static/assets/map-icons/notice.png?v=map-icons-1",
  rock: "/static/assets/map-icons/rock.png?v=map-icons-1",
  shrub: "/static/assets/map-icons/shrub.png?v=map-icons-1",
  tree: "/static/assets/map-icons/tree.png?v=map-icons-1",
  map_feature: "/static/assets/map-icons/map_feature.png?v=map-icons-1",
  gate: "/static/assets/map-icons/gate.png?v=map-icons-1",
  market: "/static/assets/map-icons/market.png?v=map-icons-1",
  tavern: "/static/assets/map-icons/tavern.png?v=map-icons-1",
  blacksmith: "/static/assets/map-icons/blacksmith.png?v=map-icons-1",
  shop: "/static/assets/map-icons/shop.png?v=map-icons-1",
  inn: "/static/assets/map-icons/inn.png?v=map-icons-1",
  barrel: "/static/assets/map-icons/barrel.png?v=map-icons-1",
  supply_sack: "/static/assets/map-icons/supply_sack.png?v=map-icons-1",
  wagon_wheel: "/static/assets/map-icons/wagon_wheel.png?v=map-icons-1",
  obelisk: "/static/assets/map-icons/obelisk.png?v=map-icons-1",
  sacrifice_altar: "/static/assets/map-icons/sacrifice_altar.png?v=temple-sacrifice-1",
  locked_door: "/static/assets/map-icons/locked_door.png?v=map-icons-1",
  zone_blob: "/static/assets/map-icons/zone_blob.png?v=zone-icons-1",
  player_walk: "/static/assets/player_walk_spritesheet.png?v=red-cape-1",
  combat_player_adventurer_base: "/static/assets/player/combat/adventurer_base.png?v=combat-player-base-1",
  ...Object.fromEntries(skeletalBasePartIds.map((partId) => [`skeletal_base_${partId}`, `/static/assets/player/skeleton/base/${partId}.png?v=player-skeleton-base-1`])),
  ...skeletalEquipmentPartPaths,
  player_rest: "/static/assets/player_rest_campfire.png",
  player_gathering: "/static/assets/player_gathering.png?v=gathering-1",
  profiles: "/static/assets/character_profiles.png",
  combat_arena: "/static/assets/combat/arena_bone_chamber.png?v=arena-map-3",
  combat_arena_city_wharf: "/static/assets/combat/arenas/arena_city_wharf.png?v=arena-map-3",
  combat_arena_city_centre: "/static/assets/combat/arenas/arena_city_centre.png?v=arena-map-3",
  combat_arena_outer_fields: "/static/assets/combat/arenas/arena_outer_fields.png?v=arena-map-3",
  combat_arena_river_beach: "/static/assets/combat/arenas/arena_river_beach.png?v=arena-map-3",
  combat_arena_mistwood_crossing: "/static/assets/combat/arenas/arena_mistwood_crossing.png?v=arena-map-3",
  combat_arena_old_watchtower: "/static/assets/combat/arenas/arena_old_watchtower.png?v=arena-map-3",
  combat_arena_smugglers_cove: "/static/assets/combat/arenas/arena_smugglers_cove.png?v=arena-map-3",
  combat_arena_deep_sewers: "/static/assets/combat/arenas/arena_deep_sewers.png?v=deep-sewers-1",
  combat_arena_watchtower_cellar: "/static/assets/combat/arenas/arena_watchtower_cellar.png?v=level20-art-1",
  combat_arena_highridge_mine: "/static/assets/combat/arenas/arena_highridge_mine.png?v=level20-art-1",
  combat_arena_black_wax_foundry: "/static/assets/combat/arenas/arena_black_wax_foundry.png?v=level20-art-1",
  combat_arena_dry_wall_sanctum: "/static/assets/combat/arenas/arena_dry_wall_sanctum.png?v=level20-art-1",
  combat_arena_market_hall: "/static/assets/combat/arenas/arena_market_hall.png?v=arena-map-3",
  combat_arena_city_tavern: "/static/assets/combat/arenas/arena_city_tavern.png?v=arena-map-3",
  combat_arena_blacksmith_shop: "/static/assets/combat/arenas/arena_blacksmith_shop.png?v=arena-map-3",
  combat_arena_general_shop: "/static/assets/combat/arenas/arena_general_shop.png?v=arena-map-3",
  combat_arena_city_inn: "/static/assets/combat/arenas/arena_city_inn.png?v=arena-map-3",
  northwood_grove: "/static/assets/maps/northwood_grove_background.png?v=world-expansion-1",
  highridge_pass: "/static/assets/maps/highridge_pass_background.png?v=world-expansion-1",
  abandoned_village: "/static/assets/maps/abandoned_village_background.png?v=world-expansion-1",
  city_sewers: "/static/assets/maps/city_sewers_background.png?v=world-expansion-1",
  deep_sewers: "/static/assets/maps/deep_sewers_background.png?v=deep-sewers-1",
  weather_cloudy_subtle: "/static/assets/weather/weather_cloudy_subtle.png?v=weather-subtle-1",
  weather_fog_subtle: "/static/assets/weather/weather_fog_subtle.png?v=weather-subtle-1",
  weather_rain_subtle: "/static/assets/weather/weather_rain_subtle.png?v=weather-subtle-1",
  world_map_asterfall: "/static/assets/maps/asterfall_world_map.png?v=world-map-1",
  tutorial_intro_1: "/static/assets/tutorial/intro_01_bandit_raid_v2.png?v=tutorial-story-2",
  tutorial_intro_2: "/static/assets/tutorial/intro_02_escape.png?v=tutorial-story-1",
  tutorial_intro_3: "/static/assets/tutorial/intro_03_refugee_barge_v2.png?v=tutorial-story-2",
  hero_melee: "/static/assets/combat/hero_melee.png",
  hero_ranged: "/static/assets/combat/hero_ranged.png",
  hero_caster: "/static/assets/combat/hero_caster.png",
  enemy_humanoid: "/static/assets/combat/enemy_humanoid.png",
  enemy_rabbit: "/static/assets/combat/enemy_rabbit.png",
  enemy_rat: "/static/assets/combat/enemy_rat.png",
  enemy_wolf: "/static/assets/combat/enemy_wolf.png",
  enemy_smuggler: "/static/assets/combat/enemy_smuggler.png",
  enemy_mistwood: "/static/assets/combat/enemy_mistwood.png?v=level20-art-1",
  enemy_miner: "/static/assets/combat/enemy_miner.png?v=level20-art-1",
  enemy_black_wax_agent: "/static/assets/combat/enemy_black_wax_agent.png?v=level20-art-1",
  enemy_dry_wall: "/static/assets/combat/enemy_dry_wall.png?v=level20-art-1",
  enemy_name_burner: "/static/assets/combat/enemy_name_burner.png?v=level20-art-1",
  enemy_snake: "/static/assets/combat/enemy_snake.png?v=deep-sewers-1",
  projectile_firebolt: "/static/assets/combat/projectile_firebolt.png",
  projectile_rock: "/static/assets/combat/projectile_rock.png",
  card_acid_flask: "/static/assets/cards/card_acid_flask.png?v=card-redesign-4",
  card_antidote_spray: "/static/assets/cards/card_antidote_spray.png?v=card-icons-5",
  card_axe_hook: "/static/assets/cards/card_axe_hook.png?v=card-icons-5",
  card_backstab: "/static/assets/cards/card_backstab.png?v=card-redesign-4",
  card_block: "/static/assets/cards/card_block.png?v=card-redesign-4",
  card_blood_roar: "/static/assets/cards/card_blood_roar.png?v=card-redesign-4",
  card_bone_splinter: "/static/assets/cards/card_bone_splinter.png?v=card-redesign-4",
  card_blessing: "/static/assets/cards/card_blessing.png?v=card-icons-5",
  card_bow_shot: "/static/assets/cards/card_bow_shot.png?v=card-tier-review-1",
  card_body_check: "/static/assets/cards/card_body_check.png?v=card-icons-5",
  card_bone_ward: "/static/assets/cards/card_bone_ward.png?v=card-icons-5",
  card_borrowed_hex: "/static/assets/cards/card_borrowed_hex.png?v=complete-card-art-1",
  card_borrowed_calm: "/static/assets/cards/card_borrowed_calm.png?v=card-expansion-1",
  card_brace_under_fire: "/static/assets/cards/card_brace_under_fire.png?v=complete-card-art-1",
  card_banked_ember: "/static/assets/cards/card_banked_ember.png?v=card-expansion-1",
  card_black_powder_snap: "/static/assets/cards/card_black_powder_snap.png?v=card-expansion-1",
  card_black_powder_toss: "/static/assets/cards/card_black_powder_toss.png?v=complete-card-art-1",
  card_calm_breath: "/static/assets/cards/card_calm_breath.png?v=complete-card-art-1",
  card_courage_shout: "/static/assets/cards/card_courage_shout.png?v=card-redesign-4",
  card_break_the_line: "/static/assets/cards/card_break_the_line.png?v=card-expansion-1",
  card_challenge: "/static/assets/cards/card_challenge.png?v=card-icons-5",
  card_choking_cloud: "/static/assets/cards/card_choking_cloud.png?v=card-icons-5",
  card_cinder_mark: "/static/assets/cards/card_cinder_mark.png?v=card-icons-5",
  card_dead_hand: "/static/assets/cards/card_dead_hand.png?v=card-icons-5",
  card_default: "/static/assets/cards/card_default.png?v=card-redesign-4",
  card_desperate_gambit: "/static/assets/cards/card_desperate_gambit.png?v=complete-card-art-1",
  card_dirty_throw: "/static/assets/cards/card_dirty_throw.png?v=complete-card-art-1",
  card_disarming_flick: "/static/assets/cards/card_disarming_flick.png?v=card-icons-5",
  card_ember_bolt: "/static/assets/cards/card_ember_bolt.png?v=card-redesign-4",
  card_empty: "/static/assets/cards/card_empty.png?v=card-redesign-4",
  card_fear_shout: "/static/assets/cards/card_fear_shout.png?v=card-redesign-4",
  card_falcon_mark: "/static/assets/cards/card_falcon_mark.png?v=card-expansion-1",
  card_field_medicine: "/static/assets/cards/card_field_medicine.png?v=complete-card-art-1",
  card_firestorm: "/static/assets/cards/card_firestorm.png?v=card-redesign-4",
  card_flame_whip: "/static/assets/cards/card_flame_whip.png?v=card-icons-5",
  card_fist_strike: "/static/assets/cards/card_fist_strike.png?v=card-redesign-4",
  card_flee: "/static/assets/cards/card_flee.png?v=card-redesign-4",
  card_focus: "/static/assets/cards/card_focus.png?v=card-redesign-4",
  card_funeral_bell: "/static/assets/cards/card_funeral_bell.png?v=card-icons-5",
  card_glass_bomb: "/static/assets/cards/card_glass_bomb.png?v=card-icons-5",
  card_grave_chill: "/static/assets/cards/card_grave_chill.png?v=card-redesign-4",
  card_grave_pact: "/static/assets/cards/card_grave_pact.png?v=card-expansion-1",
  card_grit_stance: "/static/assets/cards/card_grit_stance.png?v=complete-card-art-1",
  card_hamstring: "/static/assets/cards/card_hamstring.png?v=card-icons-5",
  card_hold_the_line: "/static/assets/cards/card_hold_the_line.png?v=card-redesign-4",
  card_hold_steady: "/static/assets/cards/card_hold_steady.png?v=complete-card-art-1",
  card_hook_and_pull: "/static/assets/cards/card_hook_and_pull.png?v=complete-card-art-1",
  card_hunter_screen: "/static/assets/cards/card_hunter_screen.png?v=card-icons-5",
  card_ignore_pain: "/static/assets/cards/card_ignore_pain.png?v=card-icons-5",
  card_inner_wall: "/static/assets/cards/card_inner_wall.png?v=card-icons-5",
  card_interpose: "/static/assets/cards/card_interpose.png?v=card-expansion-1",
  card_iron_focus: "/static/assets/cards/card_iron_focus.png?v=complete-card-art-1",
  card_judgement_blow: "/static/assets/cards/card_judgement_blow.png?v=card-expansion-1",
  card_last_stand_swing: "/static/assets/cards/card_last_stand_swing.png?v=card-expansion-1",
  card_last_resort_blade: "/static/assets/cards/card_last_resort_blade.png?v=complete-card-art-1",
  card_low_blow: "/static/assets/cards/card_low_blow.png?v=complete-card-art-1",
  card_lunge: "/static/assets/cards/card_lunge.png?v=card-redesign-4",
  card_mend_wounds: "/static/assets/cards/card_mend_wounds.png?v=card-redesign-4",
  card_measured_thrust: "/static/assets/cards/card_measured_thrust.png?v=card-icons-5",
  card_mercy_before_wrath: "/static/assets/cards/card_mercy_before_wrath.png?v=card-expansion-1",
  card_mind_lance: "/static/assets/cards/card_mind_lance.png?v=card-redesign-4",
  card_names_of_the_dead: "/static/assets/cards/card_names_of_the_dead.png?v=card-expansion-1",
  card_nerve_cut: "/static/assets/cards/card_nerve_cut.png?v=card-icons-5",
  card_oath_guard: "/static/assets/cards/card_oath_guard.png?v=card-icons-5",
  card_patched_guard: "/static/assets/cards/card_patched_guard.png?v=complete-card-art-1",
  card_parry_line: "/static/assets/cards/card_parry_line.png?v=card-icons-5",
  card_perfect_opening: "/static/assets/cards/card_perfect_opening.png?v=card-expansion-1",
  card_pinning_shot: "/static/assets/cards/card_pinning_shot.png?v=card-redesign-4",
  card_poisoned_silence: "/static/assets/cards/card_poisoned_silence.png?v=card-expansion-1",
  card_quick_coagulant: "/static/assets/cards/card_quick_coagulant.png?v=card-icons-5",
  card_quick_feint: "/static/assets/cards/card_quick_feint.png?v=card-redesign-4",
  card_quiet_step: "/static/assets/cards/card_quiet_step.png?v=card-icons-5",
  card_rally_signal: "/static/assets/cards/card_rally_signal.png?v=complete-card-art-1",
  card_read_intent: "/static/assets/cards/card_read_intent.png?v=card-icons-5",
  card_rebuke: "/static/assets/cards/card_rebuke.png?v=card-icons-5",
  card_reckless_charge: "/static/assets/cards/card_reckless_charge.png?v=card-icons-5",
  card_riposte: "/static/assets/cards/card_riposte.png?v=card-redesign-4",
  card_salt_in_wound: "/static/assets/cards/card_salt_in_wound.png?v=complete-card-art-1",
  card_salute: "/static/assets/cards/card_salute.png?v=card-icons-5",
  card_second_measure: "/static/assets/cards/card_second_measure.png?v=card-expansion-1",
  card_savage_cleave: "/static/assets/cards/card_savage_cleave.png?v=card-redesign-4",
  card_shadow_step: "/static/assets/cards/card_shadow_step.png?v=card-redesign-4",
  card_shared_focus: "/static/assets/cards/card_shared_focus.png?v=card-icons-5",
  card_shield_bash: "/static/assets/cards/card_shield_bash.png?v=card-redesign-4",
  card_shield_wall: "/static/assets/cards/card_shield_wall.png?v=card-icons-5",
  card_silent_signal: "/static/assets/cards/card_silent_signal.png?v=card-icons-5",
  card_sleeping_draught: "/static/assets/cards/card_sleeping_draught.png?v=card-expansion-1",
  card_smoke_pot: "/static/assets/cards/card_smoke_pot.png?v=complete-card-art-1",
  card_smoke_veil: "/static/assets/cards/card_smoke_veil.png?v=card-icons-5",
  card_shoot: "/static/assets/cards/card_shoot.png?v=card-redesign-4",
  card_sling_shot: "/static/assets/cards/card_sling_shot.png?v=card-tier-review-1",
  card_smite: "/static/assets/cards/card_smite.png?v=card-redesign-4",
  card_snare_shot: "/static/assets/cards/card_snare_shot.png?v=card-icons-5",
  card_spark_wall: "/static/assets/cards/card_spark_wall.png?v=card-icons-5",
  card_split_arrow: "/static/assets/cards/card_split_arrow.png?v=card-expansion-1",
  card_staff_strike: "/static/assets/cards/card_staff_strike.png?v=card-icons-5",
  card_steady_aim: "/static/assets/cards/card_steady_aim.png?v=complete-card-art-1",
  card_stinging_dust: "/static/assets/cards/card_stinging_dust.png?v=complete-card-art-1",
  card_strike: "/static/assets/cards/card_strike.png?v=card-redesign-4",
  card_sunlit_verdict: "/static/assets/cards/card_sunlit_verdict.png?v=card-expansion-1",
  card_thought_knot: "/static/assets/cards/card_thought_knot.png?v=card-expansion-1",
  card_throw_rock: "/static/assets/cards/card_throw_rock.png?v=card-redesign-4",
  card_tracking_cut: "/static/assets/cards/card_tracking_cut.png?v=card-icons-5",
  card_trail_signal: "/static/assets/cards/card_trail_signal.png?v=card-icons-5",
  card_tripwire: "/static/assets/cards/card_tripwire.png?v=complete-card-art-1",
  card_vanishing_cut: "/static/assets/cards/card_vanishing_cut.png?v=card-expansion-1",
  card_volatile_mix: "/static/assets/cards/card_volatile_mix.png?v=card-redesign-4",
  card_war_cry: "/static/assets/cards/card_war_cry.png?v=card-icons-5",
  card_war_story: "/static/assets/cards/card_war_story.png?v=complete-card-art-1",
  card_warding_prayer: "/static/assets/cards/card_warding_prayer.png?v=card-icons-5",
  card_warming_words: "/static/assets/cards/card_warming_words.png?v=card-icons-5",
  card_white_flame: "/static/assets/cards/card_white_flame.png?v=card-expansion-1",
  card_witness_whisper: "/static/assets/cards/card_witness_whisper.png?v=card-icons-5",
  menu_icon_character: "/static/assets/ui/menu/character.png?v=menu-icons-1",
  menu_icon_inventory: "/static/assets/ui/menu/inventory.png?v=menu-icons-1",
  menu_icon_deck: "/static/assets/ui/menu/deck.png?v=menu-icons-1",
  menu_icon_combat: "/static/assets/ui/menu/combat.png?v=menu-icons-1",
  menu_icon_quests: "/static/assets/ui/menu/quests.png?v=menu-icons-1",
  menu_icon_world_map: "/static/assets/ui/menu/world_map.png?v=menu-icons-1",
  menu_icon_social: "/static/assets/ui/menu/social.png?v=menu-icons-1",
  menu_icon_settings: "/static/assets/ui/menu/settings.png?v=menu-icons-1",
  character_stat_strength: "/static/assets/ui/character/strength.png?v=character-icons-1",
  character_stat_agility: "/static/assets/ui/character/agility.png?v=character-icons-1",
  character_stat_mind: "/static/assets/ui/character/mind.png?v=character-icons-1",
  character_stat_magical_power: "/static/assets/ui/character/magical_power.png?v=character-icons-1",
  character_stat_intelligence: "/static/assets/ui/character/intelligence.png?v=character-icons-1",
  character_stat_endurance: "/static/assets/ui/character/endurance.png?v=character-icons-1",
  character_stat_speed: "/static/assets/ui/character/speed.png?v=character-icons-1",
  character_stat_max_hp: "/static/assets/ui/character/max_hp.png?v=character-icons-1",
  character_stat_max_mana: "/static/assets/ui/character/max_mana.png?v=character-icons-1",
  character_stat_max_stamina: "/static/assets/ui/character/max_stamina.png?v=character-icons-1",
  character_gold: "/static/assets/ui/character/gold.png?v=character-icons-1",
  card_tag_attack: "/static/assets/ui/card-tags/tag_attack.png?v=card-tag-icons-1",
  card_tag_defense: "/static/assets/ui/card-tags/tag_defense.png?v=card-tag-icons-1",
  card_tag_buff: "/static/assets/ui/card-tags/tag_buff.png?v=card-tag-icons-1",
  card_tag_debuff: "/static/assets/ui/card-tags/tag_debuff.png?v=card-tag-icons-1",
  card_tag_melee: "/static/assets/ui/card-tags/tag_melee.png?v=card-tag-icons-1",
  card_tag_ranged: "/static/assets/ui/card-tags/tag_ranged.png?v=card-tag-icons-1",
  card_tag_mental: "/static/assets/ui/card-tags/tag_mental.png?v=card-tag-icons-1",
  card_tag_enemy: "/static/assets/ui/card-tags/tag_enemy.png?v=card-tag-icons-1",
  card_tag_ally: "/static/assets/ui/card-tags/tag_ally.png?v=card-tag-icons-1",
  card_tag_self: "/static/assets/ui/card-tags/tag_self.png?v=card-tag-icons-1",
  combat_intent_attack: "/static/assets/ui/combat-intents/intent_attack.png?v=combat-intents-1",
  combat_intent_defense: "/static/assets/ui/combat-intents/intent_defense.png?v=combat-intents-1",
  combat_intent_buff: "/static/assets/ui/combat-intents/intent_buff.png?v=combat-intents-1",
  combat_intent_debuff: "/static/assets/ui/combat-intents/intent_debuff.png?v=combat-intents-1",
  combat_intent_poison: "/static/assets/ui/combat-intents/intent_poison.png?v=combat-intents-1",
  combat_intent_bleed: "/static/assets/ui/combat-intents/intent_bleed.png?v=combat-intents-1",
  combat_intent_vulnerable: "/static/assets/ui/combat-intents/intent_vulnerable.png?v=combat-intents-1",
  combat_intent_focus: "/static/assets/ui/combat-intents/intent_focus.png?v=combat-intents-1",
  combat_intent_phase: "/static/assets/ui/combat-intents/intent_phase.png?v=combat-intents-1",
  combat_intent_unknown: "/static/assets/ui/combat-intents/intent_unknown.png?v=combat-intents-1",
};

export const audioPaths = {
  mapMusic: {
    tutorial_ash_village: "/static/assets/audio/tutorial/escape.mp3?v=audio-tutorial-1",
    tutorial_hidden_landing: "/static/assets/audio/tutorial/escape.mp3?v=audio-tutorial-1",
    tutorial_barge_hold: "/static/assets/audio/tutorial/storm.mp3?v=audio-tutorial-1",
    tutorial_storm_deck: "/static/assets/audio/tutorial/storm.mp3?v=audio-tutorial-1",
    tutorial_wreck_shore: "/static/assets/audio/tutorial/storm.mp3?v=audio-tutorial-1",
    city_wharf: "/static/assets/audio/maps/city_wharf.mp3?v=audio-map-3",
    city_centre: "/static/assets/audio/maps/city_centre.mp3?v=audio-map-3",
    outer_fields: "/static/assets/audio/maps/outer_fields.mp3?v=audio-map-3",
    river_beach: "/static/assets/audio/maps/river_beach.mp3?v=audio-map-3",
    mistwood_crossing: "/static/assets/audio/maps/mistwood_crossing.mp3?v=audio-map-3",
    old_watchtower: "/static/assets/audio/maps/old_watchtower.mp3?v=audio-map-3",
    smugglers_cove: "/static/assets/audio/maps/smugglers_cove.mp3?v=audio-map-3",
    northwood_grove: "/static/assets/audio/maps/northwood_grove.mp3?v=audio-map-4",
    highridge_pass: "/static/assets/audio/maps/highridge_pass.mp3?v=audio-map-4",
    abandoned_village: "/static/assets/audio/maps/abandoned_village.mp3?v=audio-map-4",
    last_light_temple: "/static/assets/audio/maps/last_light_temple.mp3?v=audio-map-4",
    city_sewers: "/static/assets/audio/maps/city_sewers.mp3?v=audio-map-4",
    deep_sewers: "/static/assets/audio/maps/deep_sewers.mp3?v=audio-map-4",
    market_hall: "/static/assets/audio/maps/market_hall.mp3?v=audio-map-3",
    city_tavern: "/static/assets/audio/maps/city_tavern.mp3?v=audio-map-3",
    blacksmith_shop: "/static/assets/audio/maps/blacksmith_shop.mp3?v=audio-map-3",
    general_shop: "/static/assets/audio/maps/general_shop.mp3?v=audio-map-3",
    city_inn: "/static/assets/audio/maps/city_inn.mp3?v=audio-map-3",
  },
  combatMusic: {
    tutorial_ash_village: "/static/assets/audio/tutorial/combat.mp3?v=audio-tutorial-1",
    tutorial_hidden_landing: "/static/assets/audio/tutorial/combat.mp3?v=audio-tutorial-1",
    tutorial_barge_hold: "/static/assets/audio/tutorial/combat.mp3?v=audio-tutorial-1",
    tutorial_storm_deck: "/static/assets/audio/tutorial/combat.mp3?v=audio-tutorial-1",
    tutorial_wreck_shore: "/static/assets/audio/tutorial/combat.mp3?v=audio-tutorial-1",
    city_wharf: "/static/assets/audio/combat/city_wharf.mp3?v=audio-combat-4",
    city_centre: "/static/assets/audio/combat/city_centre.mp3?v=audio-combat-4",
    outer_fields: "/static/assets/audio/combat/outer_fields.mp3?v=audio-combat-4",
    river_beach: "/static/assets/audio/combat/river_beach.mp3?v=audio-combat-4",
    mistwood_crossing: "/static/assets/audio/combat/mistwood_crossing.mp3?v=audio-combat-4",
    old_watchtower: "/static/assets/audio/combat/old_watchtower.mp3?v=audio-combat-4",
    smugglers_cove: "/static/assets/audio/combat/smugglers_cove.mp3?v=audio-combat-4",
    northwood_grove: "/static/assets/audio/combat/northwood_grove.mp3?v=audio-combat-5",
    highridge_pass: "/static/assets/audio/combat/highridge_pass.mp3?v=audio-combat-5",
    abandoned_village: "/static/assets/audio/combat/abandoned_village.mp3?v=audio-combat-5",
    last_light_temple: "/static/assets/audio/combat/last_light_temple.mp3?v=audio-combat-5",
    city_sewers: "/static/assets/audio/combat/city_sewers.mp3?v=audio-combat-5",
    deep_sewers: "/static/assets/audio/combat/deep_sewers.mp3?v=audio-combat-5",
    market_hall: "/static/assets/audio/combat/market_hall.mp3?v=audio-combat-4",
    city_tavern: "/static/assets/audio/combat/city_tavern.mp3?v=audio-combat-4",
    blacksmith_shop: "/static/assets/audio/combat/blacksmith_shop.mp3?v=audio-combat-4",
    general_shop: "/static/assets/audio/combat/general_shop.mp3?v=audio-combat-4",
    city_inn: "/static/assets/audio/combat/city_inn.mp3?v=audio-combat-4",
  },
  impact: "/static/assets/audio/sfx/impact_hit.mp3?v=audio-sfx-3",
  sfx: {
    combatHitMelee: "/static/assets/audio/sfx/combat_hit_melee.mp3?v=audio-sfx-tom-1",
    combatHitRanged: "/static/assets/audio/sfx/combat_hit_ranged.mp3?v=audio-sfx-tom-1",
    combatHitMagic: "/static/assets/audio/sfx/combat_hit_magic.mp3?v=audio-sfx-tom-1",
    combatBlockPartial: "/static/assets/audio/sfx/combat_block_partial.mp3?v=audio-sfx-tom-1",
    combatBlockFull: "/static/assets/audio/sfx/combat_block_full.mp3?v=audio-sfx-tom-1",
    combatBuff: "/static/assets/audio/sfx/combat_buff.mp3?v=audio-sfx-tom-1",
    combatDebuff: "/static/assets/audio/sfx/combat_debuff.mp3?v=audio-sfx-tom-1",
    combatFlee: "/static/assets/audio/sfx/combat_flee.mp3?v=audio-sfx-tom-1",
    combatRoundGong: "/static/assets/audio/sfx/combat_round_gong.mp3?v=audio-sfx-tom-1",
    levelUp: "/static/assets/audio/sfx/level_up.mp3?v=audio-sfx-tom-1",
    gatherStart: "/static/assets/audio/sfx/gather_start.mp3?v=audio-sfx-tom-1",
    mineStart: "/static/assets/audio/sfx/mine_start.mp3?v=audio-sfx-tom-1",
  },
  restStart: "/static/assets/audio/sfx/rest_start.mp3?v=audio-sfx-rest-2",
  restEnd: "/static/assets/audio/sfx/rest_end.mp3?v=audio-sfx-rest-1",
  uiClick: "/static/assets/audio/sfx/ui_click.mp3?v=audio-ui-1",
  cards: {
    acid_flask: "/static/assets/audio/cards/acid_flask.mp3?v=audio-card-3",
    backstab: "/static/assets/audio/cards/backstab.mp3?v=audio-card-3",
    block: "/static/assets/audio/cards/block.mp3?v=audio-card-3",
    blood_roar: "/static/assets/audio/cards/blood_roar.mp3?v=audio-card-3",
    bone_splinter: "/static/assets/audio/cards/bone_splinter.mp3?v=audio-card-3",
    courage_shout: "/static/assets/audio/cards/courage_shout.mp3?v=audio-card-3",
    ember_bolt: "/static/assets/audio/cards/ember_bolt.mp3?v=audio-card-3",
    fear_shout: "/static/assets/audio/cards/fear_shout.mp3?v=audio-card-3",
    firestorm: "/static/assets/audio/cards/firestorm.mp3?v=audio-card-3",
    fist_strike: "/static/assets/audio/cards/fist_strike.mp3?v=audio-card-3",
    flee: "/static/assets/audio/cards/flee.mp3?v=audio-card-3",
    focus: "/static/assets/audio/cards/focus.mp3?v=audio-card-3",
    grave_chill: "/static/assets/audio/cards/grave_chill.mp3?v=audio-card-3",
    hold_the_line: "/static/assets/audio/cards/hold_the_line.mp3?v=audio-card-3",
    lunge: "/static/assets/audio/cards/lunge.mp3?v=audio-card-3",
    mend_wounds: "/static/assets/audio/cards/mend_wounds.mp3?v=audio-card-3",
    mind_lance: "/static/assets/audio/cards/mind_lance.mp3?v=audio-card-3",
    pinning_shot: "/static/assets/audio/cards/pinning_shot.mp3?v=audio-card-3",
    quick_feint: "/static/assets/audio/cards/quick_feint.mp3?v=audio-card-3",
    riposte: "/static/assets/audio/cards/riposte.mp3?v=audio-card-3",
    savage_cleave: "/static/assets/audio/cards/savage_cleave.mp3?v=audio-card-3",
    shadow_step: "/static/assets/audio/cards/shadow_step.mp3?v=audio-card-3",
    shield_bash: "/static/assets/audio/cards/shield_bash.mp3?v=audio-card-3",
    shoot: "/static/assets/audio/cards/shoot.mp3?v=audio-card-3",
    smite: "/static/assets/audio/cards/smite.mp3?v=audio-card-3",
    strike: "/static/assets/audio/cards/strike.mp3?v=audio-card-3",
    throw_rock: "/static/assets/audio/cards/throw_rock.mp3?v=audio-card-3",
    volatile_mix: "/static/assets/audio/cards/volatile_mix.mp3?v=audio-card-3",
  },
};

export const playerSprite = {
  columns: 4,
  rows: 8,
  cellSize: 222,
  frameMs: 140,
  scale: 1.42,
  directions: {
    down: 0,
    down_right: 1,
    right: 2,
    up_right: 3,
    up: 4,
    up_left: 5,
    left: 6,
    down_left: 7,
  },
};

export const windowTitles = {
  character: "Character",
  inventory: "Inventory",
  deck: "Deck",
  combat: "Combat",
  quests: "Quests",
  party: "Party",
  "world-map": "World Map",
  social: "Social",
  settings: "Ustawienia",
};
